import { FC } from "react";
import { Box, BoxProps } from "@smile2impress/components/relaunch";
import { sanitizeHtml } from "@smile2impress/attraction-utils";
import { marked } from "marked";

// CMS rich-text fields store Markdown (Strapi markdown editor) with occasional
// embedded inline HTML (e.g. <u>). Convert Markdown to HTML, then sanitize.
const markdownToHtml = (markdown: string): string =>
    marked.parse(markdown, { gfm: true, breaks: true }) as string;

export interface RichTextProps extends Omit<BoxProps, "children"> {
    content: string;
}

export const RichText: FC<RichTextProps> = ({ content, sx, ...rest }) => (
    <Box
        sx={{ ...sx }}
        dangerouslySetInnerHTML={{
            __html: sanitizeHtml(markdownToHtml(content)),
        }}
        {...rest}
    />
);
